import { makeStyles } from 'tss-react/mui'

import HelpDropDown from '@src/components/shared/TopNav/HelpDropDown'
import Logo from '@src/svgs/legacy/logo-white.svg?react'

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  topSection: {
    height: 220,
    paddingTop: 10,
    textAlign: 'center',

    // TODO In mui v5 this should be something like:
    // backgroundColor: theme.palette.pbxxCyan.main,
    // color: theme.palette.pbxxCyan.contrastText,
    backgroundColor: theme.palette.pbxxCyan.main,
    color: theme.palette.common.white,

    [theme.breakpoints.up('sm')]: {
      height: 320,
      paddingTop: 50,
    },
  },
  helpContainer: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  contentContainer: {
    marginTop: -140,
    [theme.breakpoints.up('sm')]: {
      marginTop: -170,
    },
  },
}))

const AuthPageLayout: React.FC<React.PropsWithChildren> = (props) => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.topSection}>
        <Logo height="30%" width="40vw" />

        <div className={classes.helpContainer}>
          <HelpDropDown />
        </div>
      </div>

      <div className={classes.contentContainer}>{props.children}</div>
    </div>
  )
}

export default AuthPageLayout
